import React, { useMemo } from 'react';
import './Community.css';
import { CDN_URLS } from '../config/cdn';
import { DISCORD_URL } from '../config/const.js';

const Community = () => {
  const avatars = useMemo(() => {
    const ids = [];
    while (ids.length < 6) {
      const n = Math.floor(Math.random() * 15);
      if (!ids.includes(n)) ids.push(n);
    }
    return ids.map(i => CDN_URLS.avatar[i]);
  }, []);

  return (
    <section className="community">
      {/* Rotating orbit with rings & avatars */}
      <div className="community-orbit">
        {/* 3 concentric rings */}
        <div className="ring ring-3" />
        <div className="ring ring-2" />
        <div className="ring ring-1" />
        {/* Discord icon */}
        <i className="fab fa-discord central-icon" />

        {/* Avatars placed on orbit */}
        {avatars.map((src, idx) => (
          <div className={`community-orbit-inner community-orbit-inner-${idx + 1}`}>
            <img
              key={src}
              src={src}
              alt={`Community member ${idx + 1}`}
              className={`orbit-avatar avatar-${idx + 1}`}
            />
          </div>
        ))}
      </div>

      <div className="community-content">
        <h2>Join the MemU community</h2>
        <p>Engage with developers shaping memory-first AI. Share insights to advance the ecosystem.</p>
        <a href={DISCORD_URL} className="btn btn-primary btn-md" target="_blank" rel="noopener noreferrer">
          Join Discord
        </a>
      </div>
    </section>
  );
};

export default Community;